import HTTP from '@/api';
import FCMService from '@/api/FCMService';

export default (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === 'user/login') {
      HTTP.defaults.headers.common.Authorization = `Bearer ${mutation.payload.token}`;
      FCMService.validateRequestPermission();
    }

    if (mutation.type === 'user/logout') {
      HTTP.defaults.headers.common.Authorization = null;
      FCMService.deleteToken();
    }
  });
};
